<h2 mat-dialog-title>Hvilken Payter terminal vil du tilknytte?</h2>
<form>
  <button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
    <mat-icon class="material-icons">close</mat-icon>
  </button>
  <mat-dialog-content>
    <adm-loading-spinner
      [loading$]="loading$"
      [hasNoData]="(filteredSerialNumbers.length === 0 && (loading$ | async) === false) || !filteredSerialNumbers"></adm-loading-spinner>

    @if (typeAheadTerminalModel && filteredSerialNumbers.length) {
      <div class="form-row form-row--inline">
        <mat-form-field>
          <mat-label>Vælg Payter terminal</mat-label>
          <div [formGroup]="typeAheadTerminalModel">
            <input type="text" #terminalSelect formControlName="typeAheadQuery" [matAutocomplete]="auto" matInput placeholder="Vælg" />
          </div>
          <mat-autocomplete
            #auto="matAutocomplete"
            hideSingleSelectionIndicator="true"
            [displayWith]="displayFn"
            (optionSelected)="selectSerialNumber($event.option.value)"
            okCustomDropDownArrowDirective>
            @for (serialNumber of filteredSerialNumbers; track serialNumber) {
              <mat-option [value]="serialNumber">
                {{ serialNumber }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (selectedTerminal) {
            <mat-icon matSuffix class="clear-input-field-button" (click)="resetTerminalFilter()">close</mat-icon>
          }
          <mat-icon matSuffix></mat-icon>
        </mat-form-field>
      </div>
    }
    @if (filteredSerialNumbers.length === 0) {
      <ok-feedback-info>
        <b>Ingen betalingsterminaler</b>
        <br />
        <p>Der er pt. ingen betalingsterminaler, der ikke er tilknyttet nogen ladepunkter.</p>
      </ok-feedback-info>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (chargingStationIdentifier) {
      <div class="unit-identifier">
        <span>Ladestander ID:</span>
        {{ chargingStationIdentifier }}
      </div>
    }
    <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Annuller</button>
    <button
      class="actions__button margin--right-2"
      type="button"
      mat-raised-button
      color="primary"
      [disabled]="!selectedTerminal"
      (click)="openTerminalConnectorRelationModal()">
      Videre
    </button>
  </mat-dialog-actions>
</form>
